<template>
  <div>
    <h1>Common uploads</h1>
    <v-switch v-model="archived" label="Show archived" />
    <v-btn :to="{ name: 'uploadCommonAdd' }">
      <v-icon>add</v-icon>Common upload
    </v-btn>
    <v-data-table
      v-if="uploadsCommon"
      :headers="headers"
      :items="uploadsCommon"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              small
              :to="{ name: 'uploadCommon', params: { id: props.item.id } }"
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>
            <span v-if="props.item.uploadDescription">{{
              props.item.uploadDescription.body
            }}</span>
          </td>
          <td>
            <v-btn small @click="download(props.item)">
              <v-icon>picture_as_pdf</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import UPLOADS_COMMON from "@/graphql/document/UploadsCommon";
import UPLOAD_SIGNED_URL from "@/graphql/document/UploadSignedUrl";
export default {
  name: "UploadsCommon",
  metaInfo() {
    return {
      title: "Common uploads",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    uploadsCommon: {
      query: UPLOADS_COMMON,
      variables() {
        return {
          archived: this.archived
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      archived: false,
      descriptions: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Description",
          value: "description.body"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      pagination: { sortBy: "description.body", rowsPerPage: -1 }
    };
  },
  methods: {
    async download(item) {
      const response = await this.$apollo.query({
        query: UPLOAD_SIGNED_URL,
        variables: { id: item.id }
      });
      window.open(response.data.upload.signedUrlGet, "_blank");
    }
  }
};
</script>
